import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ArrowDown } from "lucide-react";
import { Link } from "gatsby";
import { EnvConstants } from "@/constants";

const footerLinks = {
  services: {
    title: "Our services",
    links: [
      { title: "Team augmentation", url: "#" },
      { title: "Mobile Development", url: "#" },
      { title: "Back-end Development", url: "#" },
      { title: "AI Development", url: "#" },
      { title: "Front-end Development", url: "#" },
      { title: "Web Development", url: "#" },
    ],
  },
  solutions: {
    title: "Solutions",
    links: [
      { title: "AI-driven software", url: "#" },
      { title: "Enterprise development", url: "#" },
      { title: "Custom Development", url: "#" },
      { title: "Healthcare Development", url: "#" },
    ],
  },
  cases: {
    title: "Cases",
    links: [
      { title: "Social media iOS app", url: "#" },
      { title: "Android app for fast delivery services", url: "#" },
      { title: "Powerful website for the enterprise SaaS", url: "#" },
      { title: "ERP for a new gen real estate", url: "#" },
      { title: "Computer vision for ID recognition", url: "#" },
      { title: "See more cases", url: "#" },
    ],
  },
  company: {
    title: "Company",
    links: [
      { title: "Who we are", url: "/about-us" },
      { title: "Clients", url: "#" },
      { title: "Jobs", url: "#" },
      { title: "Blog", url: "#" },
      { title: "Contacts", url: "#" },
    ],
  },
};

interface FooterProps {
  className?: string;
}
const Footer: React.FC<FooterProps> = ({ className }) => {
  return (
      <footer className={`w-full bg-[#e9e9f3] ${className}`}>
        <div className="flex flex-col py-12 w-full wrap-contain">
      {/* Desktop & Tablet Layout */}
      {/* <div className="hidden md:block">
        <div className="flex flex-wrap xl:justify-between gap-8">
          {Object.values(footerLinks).map((section) => (
            <div
              key={section.title}
              className="basis-full xl:max-w-fit md:basis-[calc(50%-2rem)] xl:basis-[calc(25%-2rem)]"
            >
              <h3 className="text-xl font-semibold">{section.title}</h3>
              <ul className="mt-6 space-y-6">
                {section.links.map((link) => (
                  <li key={link.title}>
                    <Link to={link.url} className="">
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div> */}

      {/* Mobile Accordion Layout */}
      {/* <div className="md:hidden">
        <Accordion type="single" collapsible className="w-full">
          {Object.values(footerLinks).map((section) => (
            <AccordionItem
              className="border-none"
              key={section.title}
              value={section.title}
            >
              <AccordionTrigger
                icon={
                  <ArrowDown className="h-8 w-8 p-2 bg-gray-100 rounded-full shrink-0 text-black font-semibold transition-transform duration-200" />
                }
                className="text-xl hover:no-underline font-semibold"
              >
                {section.title}
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-6">
                  {section.links.map((link) => (
                    <li key={link.title}>
                      <Link to={link.url} className="text-base">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div> */}

      {/* Footer Bottom Section */}
      <div className="flex flex-col xl:flex-row items-start justify-between space-y-4 xl:items-center xl:space-y-0">
        {/* Logo, Phone, and Address */}
        <div className="flex xl:flex-row xl:justify-start md:justify-between md:items-center w-full space-y-4 md:flex-row flex-col  xl:items-center xl:space-x-4 xl:space-y-0">
          <div className="flex gap-2 items-center">
            <img
              src="/logo.svg"
              alt="DevsLpane Logo"
              className="w-6 opacity-50 h-10"
            />
            <img
              src="/devslane.svg"
              alt="DevsLane Logo"
              className="w-24 opacity-50 h-10"
            />
          </div>
          <div className="flex xl:!mt-2 flex-col md:flex-row md:justify-between xl:items-center gap-4 text-sm text-gray-600 xl:flex-row">
            <a
              href={`tel:${EnvConstants.dlPhoneNumber}`}
              className="hover:underline mb-1"
            >
              {EnvConstants.dlPhoneNumber}
            </a>
            <div className="w-px h-4 bg-gray-400 mx-3 hidden xl:block"></div>
            <div className="mb-1 flex ">Sector 63, Noida - 201301.</div>
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex flex-col md:w-full md:flex-row md:justify-between xl:items-center gap-4 text-sm text-gray-600 xl:flex-row">
          <div className="flex items-center space-x-4">
            <a
              href={EnvConstants.dlLinkedInUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-gray-400 hover:text-gray-500"
            >
              <img
                src="/icons/socials/linkedin.svg"
                alt="Linkedin Logo"
                className="h-6 w-6"
              />
            </a>
            <a
              href={EnvConstants.dlTwitterUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-gray-400 hover:text-gray-500"
            >
              <img
                src="/icons/socials/twitter.svg"
                alt="Twitter Logo"
                className="h-6 w-6"
              />
            </a>
            <a
              href={EnvConstants.dlFacebookUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-gray-400 hover:text-gray-500"
            >
              <img
                src="/icons/socials/facebook.svg"
                alt="Facebook Logo"
                className="h-6 w-6"
              />
            </a>
            <a
              href={EnvConstants.dlInstagramUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-gray-400 hover:text-gray-500"
            >
              <img
                src="/icons/socials/instagram.svg"
                alt="Instagram Logo"
                className="h-6 w-6"
              />
            </a>
            {/* <a
              href={EnvConstants.dlGlassdoorUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-gray-400 hover:text-gray-500"
            >
              <img
                src="/icons/socials/glassdor.svg"
                alt="Glassdor Logo"
                className="h-6 w-6"
              />
            </a> */}
          </div>

          {/* Privacy Policy and Copyright */}
          <div className="flex items-center space-x-2 text-sm">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <div className="w-px h-4 bg-black mx-2"></div>
            <span>© 2025, Escecion Technologies Pvt. Ltd.</span>
          </div>
        </div>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
